import React from 'react';
import { Container, Row, Col, Form, InputGroup, Button } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import logo from '../../../assets/images/Logo.png';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Modal from 'react-bootstrap/Modal';
const MemberRegistration = () => {
	const [validated, setValidated] = useState(false);
	const [selectedPlanId, setSelectedPlanId] = useState(null);
	const [memberData, setMemberData] = useState(null);
	const [memberPlan, setMemberPlan] = useState(null);
	const navigate = useNavigate();
	const [show, setShow] = useState(false);
	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);
	useEffect(() => {
		const fetchData = async () => {
			try {
				const response = await axios.get(
					'https://api.getcogen.com/api/getMemberPlans',
					{
						headers: { Accept: 'application/json' },
					}
				);
				setMemberPlan(response?.data?.member_plans);
				console.log('Data retrieved successfully:', response?.data?.plans);
			} catch (error) {
				toast.error(error.response?.data?.message);
				console.error('Error fetching data:', error.message);
			}
		};

		fetchData();
	}, []);
	console.log(memberPlan, 'adssad');
	const handleSubmit = async event => {
		const form = event.currentTarget;
		if (form.checkValidity() === false) {
			event.preventDefault();
			event.stopPropagation();
		} else {
			event.preventDefault();
			const formData = new FormData(form);
			formData.append('plan_id', selectedPlanId);
			console.log(Object.fromEntries(formData), 'testing data');

			try {
				const token = `Bearer ${localStorage.getItem('token')}`;
				const response = await axios.post(
					'https://api.getcogen.com/api/memberRegisteration',
					formData,
					{
						headers: {
							'Content-Type': 'multipart/form-data',
							Accept: 'application/json',
							Authorization: token,
						},
					}
				);
				localStorage.setItem('token', response?.data?.token);
				setMemberData(response);
				toast.success(response.data.message);

				if (response.data.success === true) {
					navigate('/verificationModal', {
						state: { email: formData.get('email') },
					});
				}
				console.log(response?.data?.data, 'memberdata');
			} catch (error) {
				toast.error(error.response?.data?.message);
				console.error('Error submitting form:', error);
			}
		}

		setValidated(true);
	};
	const handleHomeClick = () => {
		navigate('/');
	};
	const handleTermsClick = () => {
		navigate('/termsOfServices');
	};
	// css
	const containerStyle = {
		fontSize: '19px',
		fontFamily: 'Calibri, sans-serif',
	};

	const pricingListStyle = {
		listStyleType: 'decimal',
		marginLeft: '0.5in',
	};

	const nestedListStyle = {
		listStyleType: 'upper-alpha',
		marginLeft: '1em',
	};
	const SixYear = memberPlan?.[0]?.time_limit;
	const OneYear = memberPlan?.[1]?.time_limit;
	return (
		<Container>
			<Row className='py-5 mt-1 align-items-center'>
				<Col md={5}>
					<img
						src={logo}
						alt='logo'
						onClick={handleHomeClick}
						style={{
							height: '10vmin',
							marginLeft: '105px',
							marginBottom: '30px',
							cursor: 'pointer',
						}}
					/>
					<h1>Welcome to Cogen</h1>
					<p className='font-italic text-muted mb-0'>
						Choose between our plan{""} {SixYear} and {" "}{OneYear} , each offering unique benefits. Find the
						perfect plan tailored to your needs and elevate your experience with
						Cogen.
					</p>
					<div style={containerStyle}>
						<ol style={pricingListStyle}>
							<ol style={nestedListStyle}>
								{memberPlan?.map(plan => (
									<li>
										<div
											className='form-check'
											style={{ marginTop: '10px' }}
											key={plan.id}
										>
											<input
												className='form-check-input'
												type='radio'
												name='plan_id'
												id={`flexRadioDefault${plan.id}`}
												value={plan.id.toString()} // Convert the id to a string as it is used as the value
												onChange={e => setSelectedPlanId(e.target.value)}
												required
											/>
											<label
												className='form-check-label'
												style={{ fontWeight: 'bold' }}
											>
												{plan?.plan_name} Program (${plan?.price})
											</label>{' '}
											<br />
											{/* <label className='form-check-label font-italic text-muted mb-0'>
												One Initial Setup Charges ${plan.annual_fee}
											</label>
											<label className='form-check-label font-italic text-muted mb-0'>
												Maintenance Charges ${plan.mentanance_fee}
											</label> */}
											{plan.plan_name === 'Basic' && (
												<>
													<label
														className='form-check-label font-italic text-muted mb-0'
														htmlFor='flexRadioDefault2'
													>
														The {plan?.time_limit} plan costs (${plan?.price})
														and automatically renews for another{' '}
														{plan?.time_limit} with auto debit. Cancellation is
														allowed only with at least 15 days remaining before
														expiration; otherwise, it renews automatically after
														completion.
													</label>
												</>
											)}
											{plan.plan_name === 'Premium' && (
												<>
													<label
														className='form-check-label font-italic text-muted mb-0'
														htmlFor='flexRadioDefault2'
													>
														The {plan?.time_limit} plan costs (${plan?.price})
														and will automatically renew for another{' '}
														{plan?.time_limit} period after the completion of
														the first year. The user can cancel the plan only 15
														days before the year ends.
													</label>
												</>
											)}
										</div>
									</li>
								))}
							</ol>

							{/* 
							<ol style={nestedListStyle}>
								<li>
									<div className='form-check' style={{ marginTop: '10px' }}>
										<input
											className='form-check-input'
											type='radio'
											name='plan_id'
											id='flexRadioDefault1'
											value='1'
											onChange={e => setSelectedPlanId(e.target.value)}
											required
										/>
										<label
											className='form-check-label'
											htmlFor='flexRadioDefault2'
											style={{ fontWeight: 'bold' }}
										>
											6th Month Program ($60)
										</label>
										<label
											className='form-check-label font-italic text-muted mb-0'
											htmlFor='flexRadioDefault2'
										>
											The 6-month plan costs $60 and automatically renews for
											another 6 months with auto debit. Cancellation is allowed
											only with at least 15 days remaining before expiration;
											otherwise, it renews automatically after completion.
										</label>
									</div>
								</li>
								<li>
									<div className='form-check' style={{ marginTop: '10px' }}>
										<input
											className='form-check-input'
											type='radio'
											name='plan_id'
											id='flexRadioDefault2'
											value='2'
											onChange={e => setSelectedPlanId(e.target.value)}
											required
										/>
										<label
											className='form-check-label'
											htmlFor='flexRadioDefault2'
											style={{ fontWeight: 'bold' }}
										>
											One Year Program ($100)
										</label>
										<label
											className='form-check-label font-italic text-muted mb-0'
											htmlFor='flexRadioDefault2'
										>
											The 1-year plan costs $100 and will automatically renew
											for another 1-year period after the completion of the
											first year. The user can cancel the plan only 15 days
											before the year ends.
										</label>
									</div>
								</li>
							</ol> */}
						</ol>
					</div>
				</Col>

				<Col sm={6}>
					<Form noValidate validated={validated} onSubmit={handleSubmit}>
						<Row className='mb-2'>
							<Form.Group as={Col} md='6' controlId='validationCustom01'>
								<Form.Label>First name</Form.Label>
								<Form.Control
									required
									type='text'
									placeholder='First name'
									name='first_name'
									defaultValue=''
								/>
								<Form.Control.Feedback type='invalid'>
									Please enter a first name.
								</Form.Control.Feedback>
							</Form.Group>
							<Form.Group as={Col} md='6' controlId='validationCustom02'>
								<Form.Label>Last name</Form.Label>
								<Form.Control
									required
									type='text'
									placeholder='Last name'
									name='last_name'
									defaultValue=''
								/>
								<Form.Control.Feedback type='invalid'>
									Please enter a last name.
								</Form.Control.Feedback>
							</Form.Group>
							<Form.Group as={Col} md='6' controlId='validationCustomUsername'>
								<Form.Label>Email</Form.Label>
								<InputGroup hasValidation>
									<InputGroup.Text id='inputGroupPrepend'>@</InputGroup.Text>
									<Form.Control
										type='email'
										placeholder='Email'
										name='email'
										aria-describedby='inputGroupPrepend'
										required
									/>
									<Form.Control.Feedback type='invalid'>
										Please choose a email.
									</Form.Control.Feedback>
								</InputGroup>
							</Form.Group>
							<Form.Group as={Col} md='6' controlId='validationCustomUsername'>
								<Form.Label>Contact number</Form.Label>
								<InputGroup hasValidation>
									<Form.Control
										type='text'
										placeholder='Contact number'
										name='phone'
										aria-describedby='inputGroupPrepend'
										required
									/>
									<Form.Control.Feedback type='invalid'>
										Please enter a contact number.
									</Form.Control.Feedback>
								</InputGroup>
							</Form.Group>
							{/* <Form.Group as={Col} md='6' controlId='validationCustom01'>
								<Form.Label>Company name</Form.Label>
								<Form.Control
									required
									type='text'
									placeholder='Company name'
									defaultValue=''
								/>
								<Form.Control.Feedback type='invalid'>
									Please enter company name
								</Form.Control.Feedback>
							</Form.Group>
							<Form.Group as={Col} md='6' controlId='validationCustom02'>
								<Form.Label>Company registration number </Form.Label>
								<Form.Control
									required
									type='text'
									placeholder='Company registration number'
									defaultValue=''
								/>
								<Form.Control.Feedback type='invalid'>
									Please enter company registration number
								</Form.Control.Feedback>
							</Form.Group> */}
						</Row>
						<Row>
							<Form.Group as={Col} md='6' controlId='validationCustom04'>
								<Form.Label>State</Form.Label>
								<Form.Control
									type='text'
									name='state'
									placeholder='State'
									required
								/>
								<Form.Control.Feedback type='invalid'>
									Please provide a state.
								</Form.Control.Feedback>
							</Form.Group>
							<Form.Group as={Col} md='6' controlId='validationCustom03'>
								<Form.Label>City</Form.Label>
								<Form.Control
									type='text'
									name='city'
									placeholder='City'
									required
								/>
								<Form.Control.Feedback type='invalid'>
									Please provide a city.
								</Form.Control.Feedback>
							</Form.Group>
						</Row>
						<Row>
							<Form.Group as={Col} md='6' controlId='validationCustom02'>
								<Form.Label> Password </Form.Label>
								<Form.Control
									required
									type='password'
									name='password'
									placeholder='Password '
									defaultValue=''
								/>
								<Form.Control.Feedback type='invalid'>
									Please enter Password{' '}
								</Form.Control.Feedback>
							</Form.Group>
							<Form.Group as={Col} md='6' controlId='validationCustom02'>
								<Form.Label>Confirm password </Form.Label>
								<Form.Control
									required
									type='password'
									name='confirm_password'
									placeholder='Confirm password '
									defaultValue=''
								/>
								<Form.Control.Feedback type='invalid'>
									Please enter Confirm password{' '}
								</Form.Control.Feedback>
							</Form.Group>
						</Row>
						<Form.Group className='mb-3 mt-3 d-flex align-items-center'>
							<Form.Check
								required
								// label='Agree to terms and conditions'
								feedback='You must agree before submitting.'
								feedbackType='invalid'
							//
							/>
							<span

								onClick={handleShow}
								style={{ cursor: 'pointer', marginLeft: '8px' }}
							>
								Agree to terms and conditions
							</span>
						</Form.Group>
						<Button type='submit'>Create your account</Button>
					</Form>
					<div className='form-group col-lg-12 ' style={{ marginTop: '15px' }}>
						<p className='text-muted fw-bold'>
							Already Registered? <a href='/'>Login</a>
						</p>
					</div>
				</Col>
			</Row>
			<>
				<Modal
					show={show}
					onHide={handleClose}
					backdrop='static'
					keyboard={false}
				>
					<Modal.Header closeButton>
						<Modal.Title>NOTE</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						Please save all your data before leaving this page to prevent any
						loss. Your progress is important to us!
					</Modal.Body>
					<Modal.Footer>
						<Button variant='secondary' onClick={handleClose}>
							Close
						</Button>
						<Button variant='primary' onClick={handleTermsClick}>
							Understood
						</Button>
					</Modal.Footer>
				</Modal>
			</>
		</Container>
	);
};

export default MemberRegistration;
